import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyNougatIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./NougatIcon-133d19af.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyNougatIcon as P };
